module.exports = __webpack_public_path__ + "img/27.2aa68c80.jpg";